import React, { useState, useEffect, useContext } from 'react';
import { SiteContext } from '../context';


const DoQuantity = ({itemid}) => {

    const { products, getItemTotal, manageCartNew } = useContext(SiteContext);

    const [itemQty, setItemQty] = useState(0);
    const [item, setItem] = useState({});

    useEffect(() => {
        getProduct(itemid);
    }, [itemid])
    
    const getProduct = (itemid) => {
        let theitem = products.filter((item) => item.id === itemid);

        setItem(theitem[0]);
        setItemQty(getItemTotal(theitem[0].id))
    }

    const updateQty = (sign, itemQty) => {
        if (sign === '+') {
            setItemQty(parseInt(itemQty) + 1)
        } else if(sign === '-') {
            if (itemQty >= 1) {
                setItemQty(parseInt(itemQty) - 1)
            } else {
                manageCartNew('delete', item.id)
            }
        }
    }

    return (
        <div>   
            <p className='h5'><button className='btn btn-white btn-sm border border-dark' onClick={() => updateQty('-', itemQty)}><span className='h6'>-</span></button> <button className='btn btn-white btn-sm border border-dark'><span className='h6'>{itemQty}</span></button> <button className='btn btn-white btn-sm border border-dark' onClick={() => { getItemTotal(item.id) >= item.totalQty ? alert('Your cart quantity for ' + item.name + ' exceeds avaialble quantity') : updateQty('+', itemQty) }}><span className='h6'>+</span></button> {itemQty > 0 && <button className='btn btn-sm bg-light border border-dark rounded-pill px-3 py-1 m-1' onClick={() => manageCartNew(itemQty, 'update', item.id, item.name, item.price)}>{`${itemQty === 1 ? 'Add' : 'Update'}`}</button>}</p>
        </div>           
    )
}

export default DoQuantity;